import { useLang } from "hooks/useLang"
import Image from "next/image"
import React from "react"

const InstagramBanner = () => {
    const { t } = useLang()
    return (
        <a
            href="https://www.instagram.com/passtickets"
            target="_blank"
            rel="noopener noreferrer"
            className="flex justify-center items-center gap-2 w-full max-w-[900px] mx-auto cursor-pointer hover:opacity-80 transition-all"
        >
            {/* Instagram Circle */}
            <div
                className=" w-[55px] h-[55px] rounded-full flex items-center justify-center
        bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF]"
            >
                <Image
                    src="/svg/instagram.svg"
                    alt="Instagram"
                    width={30}
                    height={30}
                    className="w-[30px]"
                />
            </div>

            {/* Gradient Outline Button */}

            <span className="text-xl font-bold text-black text-center ">
                {t("InstagramBanner_title")}
            </span>
            {/* <div className="flex-1 p-[3px] w-[100%] rounded-full bg-gradient-to-r from-[#DD2A7B] via-[#FEDA75] to-[#F58529]">
        <div className="w-full h-[50px] rounded-full bg-white  py-6 flex items-center">
         
        </div>
      </div> */}
        </a>
    )
}

const NeverMissOutSection = () => {
    const { t } = useLang()
    return (
        <div className="w-full py-[30px] px-5 md:max-w-[1230px] layout ">
            <div
                className=" w-full   flex flex-col md:h-[260px] py-5 md:py-0 bg-cover bg-center bg-no-repeat rounded-xl"
                style={{
                    backgroundImage: "url('/images/section1.jpg')",
                }}
            >
                <div className="flex flex-row md:justify-between   h-full  w-full">
                    <div className="flex flex-col md:w-[40%] items-center justify-between md:justify-center h-full py-[40px] gap-2 md:py-0 md:gap-3  w-full ">
                        <div className=" items-center flex flex-col px-4 md:w-[70%] w-full">
                            <span className="text-black text-[32px] font-bold text-center md:text-left ">
                                {t("NeverMissOutSection_title")}
                            </span>
                            <span className="text-[#7C7C7C] text-[18px] text-center">
                                {t("NeverMissOutSection_desc")}
                            </span>
                        </div>
                        <InstagramBanner />
                    </div>

                    <div className="md:flex hidden items-end md:flex-row    ">
                        <Image
                            src={"/svg/phone2.svg"}
                            alt="phone"
                            width={353}
                            height={700}
                            className="w-[353px] h-auto "
                        />
                        <div className="w-[50px]" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NeverMissOutSection
